module.exports = __webpack_public_path__ + "static/media/bm-zm50.33bf3f7b.png";